









































































































































import { component as DirtyCheckComposer } from '@/composers/dirty-check';
import { component as FetchDataComposer } from '@/composers/fetch-data';
import { component as StoreRegisterComposer } from '@/composers/store-register';
import store from '../../store/vendor';
import View from './View';

const storeName = 'vendor';

export default DirtyCheckComposer(storeName,
  FetchDataComposer(
    StoreRegisterComposer(
      storeName,
      store,
      View(storeName),
    ),
  ),
) as IView;
